import { defineComponent as a, openBlock as t, createBlock as n, unref as o, withCtx as q, createElementVNode as r } from "vue";
import i from "../SfIconBase/SfIconBase.vue.mjs";
import { SfIconSize as m } from "@storefront-ui/shared";
const h = /* @__PURE__ */ a({
  __name: "SfIconTune",
  props: {
    size: {
      type: String,
      default: m.base
    }
  },
  setup(A) {
    return (f, e) => (t(), n(o(i), {
      size: A.size,
      viewBox: "0 0 24 24",
      "data-testid": "tune"
    }, {
      default: q(() => e[0] || (e[0] = [
        r("path", { d: "M4 19a.97.97 0 0 1-.712-.288A.97.97 0 0 1 3 18q0-.424.288-.712A.97.97 0 0 1 4 17h4q.425 0 .713.288A.97.97 0 0 1 9 18q0 .424-.287.712A.97.97 0 0 1 8 19zM4 7a.97.97 0 0 1-.712-.287A.97.97 0 0 1 3 6q0-.425.288-.713A.97.97 0 0 1 4 5h8a.97.97 0 0 1 .713.287A.97.97 0 0 1 13 6a.97.97 0 0 1-.287.713A.97.97 0 0 1 12 7zm8 14a.97.97 0 0 1-.712-.288A.97.97 0 0 1 11 20v-4q0-.425.288-.713A.97.97 0 0 1 12 15a.97.97 0 0 1 .713.287A.97.97 0 0 1 13 16v1h7q.424 0 .712.288A.97.97 0 0 1 21 18q0 .424-.288.712A.97.97 0 0 1 20 19h-7v1q0 .424-.287.712A.97.97 0 0 1 12 21m-4-6a.97.97 0 0 1-.713-.288A.97.97 0 0 1 7 14v-1H4a.97.97 0 0 1-.712-.288A.97.97 0 0 1 3 12q0-.425.288-.713A.97.97 0 0 1 4 11h3v-1a.97.97 0 0 1 .287-.713A.97.97 0 0 1 8 9a.97.97 0 0 1 .713.287A.97.97 0 0 1 9 10v4q0 .424-.287.712A.97.97 0 0 1 8 15m4-2a.97.97 0 0 1-.712-.288A.97.97 0 0 1 11 12q0-.425.288-.713A.97.97 0 0 1 12 11h8q.424 0 .712.287.288.288.288.713 0 .424-.288.712A.97.97 0 0 1 20 13zm4-4a.97.97 0 0 1-.712-.288A.97.97 0 0 1 15 8V4q0-.425.288-.713A.97.97 0 0 1 16 3q.424 0 .712.287Q17 3.575 17 4v1h3q.424 0 .712.287Q21 5.575 21 6a.97.97 0 0 1-.288.713A.97.97 0 0 1 20 7h-3v1q0 .424-.288.712A.97.97 0 0 1 16 9" }, null, -1)
      ])),
      _: 1
    }, 8, ["size"]));
  }
});
export {
  h as default
};
